import { createOrganizationApi, CreateOrganizationPayloadType } from '@/api/v1/organization/createOrganizationApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const createOrganization = async (payload: CreateOrganizationPayloadType) => {
  try {
    const response = await createOrganizationApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
